// imports section Start
import React, { useState, useEffect, useRef, createContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  useMediaQuery,
  Grid,
  IconButton,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  CircularProgress,
  Alert,
  Drawer,
  Pagination,
  tabsClasses,
  Button,
} from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";

import { BASEURL, IMAGEBASEURL } from "../../../../config/Config";
import {
  externalgetApi,
  externalpostApi,
} from "../../../../services/external/externalApis";
import {
  COMMON_API_02,
  CASHIER_API_03,
  CASHIER_API_02,
} from "../../../../api/ApiModel";
import {
  addCashierItemToCart,
  clearCashierCart,
} from "../../../../store/ReduxCashierCartReducer";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../../../utils/sys/Constants";
import SnackbarMessage from "../../../../components/common/SnackbarMessage";
import { ADD_TO_CART } from "../../../../utils/sys/Messages";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { resetVouchers } from "../../../../store/ReduxVoucherSlice";
import { clearSlips } from "../../../../store/ReduxSlipSlice";
import { clearCheque } from "../../../../store/ReduxChequeSlice";
import { resetCards } from "../../../../store/ReduxCardSlice";
import dayjs from "dayjs";
import {
  clearLoyaltyData,
  setRedeemAmount,
} from "../../../../store/ReduxLoyaltySlice";

import CashierItemCardMobile from "./CashierItemCardMobile";

import CashierCategoryMobile from "./CashierCategoryMobile";
import Header from "../../../common/Header";
import CashierSearchMobile from "./CashierSearchMobile";

// import CashierPaymentMobile from "../../../components/mobile/cashier/cashier/CashierPaymentMobile";
// import CashierPaymentMobile from "../../../components/mobile/cashier/cashier/CashierPaymentMobile";

// Create a context
export const CashierContext = createContext();

// imports section End

const CashierContentMobile = () => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const tabsRef = useRef(null);
  const dispatch = useDispatch();
  const [value, setValue] = useState("All");
  const [mainDrawerOpen, setMainDrawerOpen] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [data, setData] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const { state } = useLocation();
  const navigate = useNavigate();
  const cardList = useSelector((state) => state.cards.cardList);
  const chequeList = useSelector((state) => state.cheques.chequeList);
  const slipList = useSelector((state) => state.slips.slipList);
  const voucherList = useSelector((state) => state.vouchers.voucherList);
  const [selectedTab, setSelectedTab] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // State to store the calculated totals
  const [cardTotalAmount, setCardTotalAmount] = useState(0);
  const [slipTotalAmount, setSlipTotalAmount] = useState(0);
  const [chequeTotalAmount, setChequeTotalAmount] = useState(0);
  const [voucherTotalAmount, setVoucherTotalAmount] = useState(0);
  const [addonsData, setAddonsData] = useState([]); // Store fetched addons
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // Number of items per page

  useEffect(() => {
    // if (isLoggedIn && COMPCODE && LOCCODE && RESTCODE) {
    fetchData();
    fetchCategories();
    // }
  }, []);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  // Handlers start
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  // Check if user is logged in
  const isLoggedIn = !!USERREFCODE;
  // Calculate totals dynamically whenever the lists change
  useEffect(() => {
    const calcCardTotal = cardList.reduce((total, card) => {
      const amount = parseFloat(card.cardamount) || 0;
      return total + amount;
    }, 0);
    setCardTotalAmount(calcCardTotal);

    const calcSlipTotal = slipList.reduce((total, slip) => {
      const amount = parseFloat(slip.slipamount) || 0;
      return total + amount;
    }, 0);
    setSlipTotalAmount(calcSlipTotal);

    const calcChequeTotal = chequeList.reduce((total, cheque) => {
      const amount = parseFloat(cheque.chequeamount) || 0;
      return total + amount;
    }, 0);
    setChequeTotalAmount(calcChequeTotal);
  }, [cardList, slipList, chequeList]); // Recalculate whenever these lists change

  // Calculate totals dynamically whenever the lists change
  useEffect(() => {
    const calcVoucherTotal = voucherList.reduce((total, voucher) => {
      const amount = parseFloat(voucher.voucheramount) || 0;
      return total + amount;
    }, 0);
    setVoucherTotalAmount(calcVoucherTotal);
  }, [voucherList]); // Recalculate whenever these lists change

  // Function to handle numeric inputs (advance and cash tendered)
  const handleNumericInput = (value, setState) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setState(value);
    }
  };

  useEffect(() => {
    dispatch(setRedeemAmount(""));
    dispatch(clearCashierCart());
    dispatch(resetVouchers());
    dispatch(clearSlips());
    dispatch(clearCheque());
    dispatch(resetCards());
    dispatch(clearLoyaltyData());
  }, [dispatch]);

  const handleAddToCart = (item) => {
    if (isLoggedIn) {
      dispatch(addCashierItemToCart(item));
    } else {
      alert("Please log in to add items to the cart.");

      setSnackbarMessage(ADD_TO_CART);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    // Filter items based on the search query
    const filtered = allItems.filter(
      (item) =>
        item.MENUNAME.toLowerCase().includes(query.toLowerCase()) ||
        item.MENUREFCODE.toLowerCase().includes(query.toLowerCase())
    );
    // Sort items alphabetically by MENUNAME
    const sortedFilteredItems = filtered.sort((a, b) =>
      a.MENUNAME.localeCompare(b.MENUNAME)
    );
    setFilteredItems(sortedFilteredItems);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    filterItems(newValue);

    // Scroll to the selected tab
    const tabElement = tabsRef.current?.querySelector(
      `button[value="${newValue}"]`
    );
    tabElement?.scrollIntoView({ behavior: "smooth", inline: "center" });
  };

  const filterItems = (categoryCode) => {
    if (categoryCode === "All") {
      setFilteredItems(allItems);
    } else {
      setFilteredItems(
        allItems.filter((item) => item.MENUCATCODE === categoryCode)
      );
    }
  };
  const handleToggleDrawer = () => {
    setMainDrawerOpen(!mainDrawerOpen);
  };
  const handleCategoryDialogOpen = () => setCategoryDialogOpen(true);
  const handleCategoryDialogClose = () => setCategoryDialogOpen(false);

  const handleSelectCategory = (category) => {
    setValue(category.MENUCATCODE);
    filterItems(category.MENUCATCODE);
    setCategoryDialogOpen(false);
  };

  const handleViewOrder = (order) => setSelectedOrder(order);

  const sortedCategories = categories
    .filter((category) => category.MENUCATCODE !== "All")
    .sort((a, b) => a.MENUCATNAME.localeCompare(b.MENUCATNAME));

  const uniqueCategories = [
    { MENUCATCODE: "All", MENUCATNAME: "All" },
    ...dynamicCategories,
    ...sortedCategories,
  ].reduce((acc, category) => {
    if (!acc.some((cat) => cat.MENUCATCODE === category.MENUCATCODE)) {
      acc.push(category);
    }
    return acc;
  }, []);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const calculateItemTotal = (item) => {
    // console.log("Item received for calculation:", item); // Debug log
    const rate = parseFloat(item.ITEMRATE || item.RATE || 0); // Check both ITEMRATE and RATE
    const quantity = parseFloat(item.quantity || item.QTY || 1);
    // console.log(`Rate: ${rate}, Quantity: ${quantity}`); // Debug log
    return rate * quantity;
  };

  // Handlers end

  // API calls start
  const fetchData = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(COMMON_API_02, "GET", params);
      setAllItems(response);
      setFilteredItems(response);
    } catch (error) {
      setError(error);
    } finally {
      setData(true);
    }
  };

  const fetchCategories = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        MENUTYPECODE: CON_MENU_TYPE_CODE,
        STS: CON_STATUS_ACTIVE,
      };
      const categoryResponse = await externalgetApi(
        COMMON_API_02,
        "GET",
        params
      );

      setCategories(categoryResponse);
    } catch (error) {
      setError(error);
    }
  };
  // API calls end

  return (
    <>
      <Box sx={{ height: "82vh", py: 1, my: 1 }}>
        <Box ref={tabsRef} sx={styles.m_tabs_container}>
          {/* Fixed "All items" tab */}

          <Box sx={styles.m_tabs_list}>
            <Box>
              <Tab
                key="All"
                value="All"
                label="All"
                sx={{
                  ...styles.m_tab_fixed,
                  ...(value === "All" && styles.tab_selected),
                  boxShadow:
                    value === "All" ? "0px 4px 6px rgba(0, 0, 0, 0.1)" : "none",
                }}
                onClick={() => handleChange(null, "All")}
              />
            </Box>

            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              aria-label="scrollable auto tabs example"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                flexGrow: 1,
                maxWidth: { xs: "100%", sm: "100%" },
                [`& .${tabsClasses.scrollButtons}`]: {
                  "&.Mui-disabled": { opacity: 0.3 },
                },
              }}
            >
              {uniqueCategories
                .filter((category) => category.MENUCATCODE !== "All")
                .map((category) => (
                  <Tab
                    key={category.MENUCATCODE}
                    value={category.MENUCATCODE}
                    label={category.MENUCATNAME}
                    sx={{
                      ...styles.m_tab,
                      ...(value === category.MENUCATCODE &&
                        styles.tab_selected),
                      boxShadow:
                        value === category.MENUCATCODE
                          ? "0px 4px 6px rgba(0, 0, 0, 0.9)"
                          : "none",
                    }}
                  />
                ))}
            </Tabs>
          </Box>
          <IconButton
            sx={styles.header_tab_popup_icon}
            onClick={handleCategoryDialogOpen}
          >
            <ListIcon />
          </IconButton>
        </Box>
        <Box sx={{ my: 1 }}>
          {" "}
          <CashierSearchMobile
            searchQuery={searchQuery}
            handleSearch={handleSearch}
            showSearch={true}
          />
        </Box>
        <Box sx={styles.m_cards_container}>
          <Grid container spacing={0}>
            {data ? (
              currentItems.map((item, index) => (
                <Grid item xs={6} sm={6} md={6} lg={3} xl={3} key={index}>
                  <CashierItemCardMobile
                    cashierItem={item}
                    IMAGEBASEURL={IMAGEBASEURL}
                    onViewOrder={handleViewOrder}
                    onAddToCart={handleAddToCart}
                  />
                </Grid>
              ))
            ) : (
              <Box sx={styles.progress_circular}>
                <CircularProgress />
              </Box>
            )}
            {error && (
              <Grid item xs={12}>
                <Alert severity="error">
                  Error fetching data: {error.message}
                </Alert>
              </Grid>
            )}
          </Grid>
          <Box
            sx={{
              "@media (max-width: 600px)": {
                width: "100%", // Full-width pagination on smaller screens
                display: "flex",
                justifyContent: "center",
              },
            }}
          >
            <Pagination
              count={Math.ceil(filteredItems.length / itemsPerPage)}
              page={currentPage}
              onChange={(event, value) => setCurrentPage(value)}
              color="primary"
            />
          </Box>
        </Box>
      </Box>
      <Dialog
        open={categoryDialogOpen}
        onClose={handleCategoryDialogClose}
        aria-labelledby="category-dialog-title"
      >
        {/* <DialogContent> */}
        <CashierCategoryMobile
          categories={categories}
          onSelectCategory={handleSelectCategory}
          onClose={handleCategoryDialogClose}
        />
        {/* </DialogContent> */}
      </Dialog>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </>
  );
};

export default CashierContentMobile;
